<template>
  <div class="profilePage--navbar text-left">

    <!-- Logo -->
    <div class="logo">
      <router-link exact to="/manage-product">
        <img src="@/assets/logo.png" alt="Logo">
      </router-link>
    </div>

    <!-- Main Menu -->
    <ul class="nav">
      <!-- Newsletter -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/newsletter-subscripers"
        ><img src="@/assets/users.png" alt="Orders"> Newsletter</router-link>
      </li>
<!-- users carts -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/users-carts"
        ><img src="@/assets/users.png" alt="Orders"> Users Carts</router-link>
      </li>
      <!-- Orders -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/all-orders"
        ><img src="@/assets/orders.png" alt="Orders"> Orders</router-link>
      </li>
      <!--Tailors Orders -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/tailor-orders"
        ><img src="@/assets/orders.png" alt="Orders">Tailors Orders</router-link>
      </li>
      <!-- Products -->
      <li class="has-dropdown">
        <a
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          data-toggle="collapse"
          href="#collapseProducts"
          aria-expanded="false"
          aria-controls="collapseProducts"
        ><img src="@/assets/products.png" alt="Products"> Products <i class="fas fa-chevron-down"></i></a>
        <div class="collapse" id="collapseProducts">
          <ul class="list-group">
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/manage-product"
              >View All</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/add-product"
              >Add New</router-link>
            </li>
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseProductTypes"
                aria-expanded="false"
                aria-controls="collapseProductTypes"
              >Products Types</a>
              <div class="collapse" id="collapseProductTypes">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/General"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/addCategory"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>

      <!-- Materials -->
      <li class="has-dropdown">
        <a
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          data-toggle="collapse"
          href="#collapseMaterials"
          aria-expanded="false"
          aria-controls="collapseMaterials"
        ><img src="@/assets/materials.png" alt="Materials" style="margin-bottom: 2px;"> Materials <i class="fas fa-chevron-down"></i></a>
        <div class="collapse" id="collapseMaterials">
          <ul class="list-group">
            <!-- Accessory -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseAccessory"
                aria-expanded="false"
                aria-controls="collapseAccessory"
              >Accessory</a>
              <div class="collapse" id="collapseAccessory">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Accessory"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddAccessory"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Fabric -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseFabric"
                aria-expanded="false"
                aria-controls="collapseFabric"
              >Komasha</a>
              <div class="collapse" id="collapseFabric">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Fabric"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddFabric"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Color -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseColor"
                aria-expanded="false"
                aria-controls="collapseColor"
              >Color</a>
              <div class="collapse" id="collapseColor">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Color"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddColor"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <!-- shoes colors -->
            
            <!-- Color -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseShoeColor"
                aria-expanded="false"
                aria-controls="collapseShoeColor"
              >Shoes Colors</a>
              <div class="collapse" id="collapseShoeColor">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/ShoesColors"
                    >View All</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <!-- Fabrics -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapsefabrics"
                aria-expanded="false"
                aria-controls="collapsefabrics"
              >Fabrics</a>
              <div class="collapse" id="collapsefabrics">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/Fabrics"
                    >View All</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <!-- Sizes -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapsesizes"
                aria-expanded="false"
                aria-controls="collapsesizes"
              >Sizes</a>
              <div class="collapse" id="collapsesizes">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/Sizes"
                    >View All</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <!--winter collection Sizes -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseWinterCollectionsizes"
                aria-expanded="false"
                aria-controls="collapseWinterCollectionsizes"
              >Winter Collection sizes</a>
              <div class="collapse" id="collapseWinterCollectionsizes">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/winter-collection-sizes"
                    >View All</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Yaka -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseYaka"
                aria-expanded="false"
                aria-controls="collapseYaka"
              >Yaka</a>
              <div class="collapse" id="collapseYaka">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Yaka"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddYaka"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Zarzour -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseZarzour"
                aria-expanded="false"
                aria-controls="collapseZarzour"
              >Zarzour</a>
              <div class="collapse" id="collapseZarzour">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Zarzour"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddZarzour"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Akmam -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseAkmam"
                aria-expanded="false"
                aria-controls="collapseAkmam"
              >Akmam</a>
              <div class="collapse" id="collapseAkmam">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Akmam"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddAkmam"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Betana -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseBetana"
                aria-expanded="false"
                aria-controls="collapseBetana"
              >Betana</a>
              <div class="collapse" id="collapseBetana">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/editCategory/Betana"
                    >View All</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/AddBetana"
                    >Add New</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </li>

      <!-- Users -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/users"
        ><img src="@/assets/users.png" alt="Users"> Users</router-link>
      </li>

      <!-- Send SMS -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/sms"
        ><img src="@/assets/sms.png" alt="SMS"> SMS</router-link>
      </li>

<!-- App Messages -->
      <li>
        <router-link
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          active-class="active"
          exact
          to="/app-messages"
        ><img src="@/assets/sms.png" alt="SMS"> App Messages</router-link>
      </li>
      <!-- Pages -->
      <li class="has-dropdown">
        <a
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          data-toggle="collapse"
          href="#collapsePages"
          aria-expanded="false"
          aria-controls="collapsePages"
        ><img src="@/assets/pages.png" alt="Pages"> Pages <i class="fas fa-chevron-down"></i></a>
        <div class="collapse" id="collapsePages">
          <ul class="list-group">
            
            <!-- Homepage -->
            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseHomepage"
                aria-expanded="false"
                aria-controls="collapseHomepage"
              >Homepage</a>
              <div class="collapse" id="collapseHomepage">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/home-sections"
                    >Home Sections</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/banner"
                    >Banner</router-link>
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/ThreeStepsSection"
                    >Design Thoob Steps</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <li class="list-group-item">
              <a
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                data-toggle="collapse"
                href="#collapseCoupons"
                aria-expanded="false"
                aria-controls="collapseCoupons"
              >Coupons</a>
              <div class="collapse" id="collapseCoupons">
                <ul class="list-group">
                  <li class="list-group-item">
                    <router-link
                      :class="isDisabled?'nav-link disabled-link':'nav-link'"
                      active-class="active"
                      exact
                      to="/general-coupons"
                    >General Coupons</router-link>
                  </li>
                </ul>
              </div>
            </li>
            
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/info"
              >About</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/questions"
              >FAQs</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/branches"
              >Contact (Manage Branches)</router-link>
            </li>

          </ul>
        </div>
      </li>

      <!-- Settings -->
      <li class="has-dropdown">
        <a
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          data-toggle="collapse"
          href="#collapseSettings"
          aria-expanded="false"
          aria-controls="collapseSettings"
        ><img src="@/assets/settings.png" alt="Settings"> Settings <i class="fas fa-chevron-down"></i></a>
        <div class="collapse" id="collapseSettings">
          <ul class="list-group">
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/places"
              >Locations</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/partners"
              >Partners</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/banks"
              >Banks</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/contact-emails"
              >Contact Emails</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/admins"
              >Admins</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/privacy-policy"
              >Privacy Policy</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/pull-back-policy"
              >Pull Back Policy</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/terms"
              >Terms And Condetions</router-link>
            </li>
            <li class="list-group-item">
              <router-link
                :class="isDisabled?'nav-link disabled-link':'nav-link'"
                active-class="active"
                exact
                to="/delivery-policy"
              >Delivery Policy</router-link>
            </li>
          </ul>
        </div>
      </li>

      <!-- Logout -->
      <li>
        <a
          :class="isDisabled?'nav-link disabled-link':'nav-link'"
          v-on:click="logout"
          href="#"
        ><img src="@/assets/logout.png" alt="Logout"> Logout</a>
      </li>
    </ul>
  
    <!-- Notes -->
    <ul class="notes list-unstyled">
      <li>*Admin panel is only stable on Chrome</li>
      <li>*Maximum file size upload 1MB</li>
      <li>*Images only .jpg or .png</li>
    </ul>

  </div>
</template>
<script>
import "jquery";
import "bootstrap/js/dist/collapse";
import { deleteCookie } from "../cookie.js";
export default {
  name: "Navigation",
  props: { isDisabled: Boolean },
  methods: {
    logout() {
      deleteCookie("user");
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
<style lang="scss" scoped>
.disabled-link {
  pointer-events: none;
  opacity: 0.6;
}
.profilePage {
  &--navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 20%;
    height: 100%;
    background: #000;
    color: #fff;
    z-index: 99;

    .logo {
      margin: 20px 0;
      text-align: center;

      a {
        padding: 0;
        img {
          width: 100px;
        }
      }

    }

    .notes {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      height: 90px;
      padding: 0.5rem 0.5rem 0.5rem 1rem;
      margin-bottom: 0;
      border-bottom: 1px solid #270f14;
      
      li {
        width: 100%;
        font-size: 11px;
        color: #bfbfbf;
      }
    }

    .nav {
      max-height: calc(100vh - 90px);
      overflow-y: auto;

      li {
        display: block;
        width: 100%;
        
        a {
          display: flex;
          align-items: center;

          img {
            width: 18px;
            margin-right: 10px;
          }
        }
      }
    }

    // General link style (Applies for all menu-levels)
    a {
      padding: 10px 10px 10px 15px;
      color: #b78b1e;
      transition: all 300ms ease;
    }

    // All First-level links
    .nav > li > a {
      &:focus,
      &:active,
      &:hover {
        color: #b78b1e;
        background: #fff;
      }
    }

    // Menus with sub-menu
    .has-dropdown {
      // First-level
      > a {
        position: relative;

        i {
          position: absolute;
          right: 20px;
        }

        &:focus,
        &:hover {
          background: #fff;
        }
      }


      // Second-level
      div > ul {
        margin-left: 10px;

        li {
          background-color: #0f0f0f;
          padding: 0;
          border: 0;

          > a {
            &:focus,
            &:hover {
              color: #fff;
            }
          }
        }
      }

      // Third-level
      div > ul li > div ul {
        margin-left: 20px;

        li {
          background-color: #080808;
        }
      }
    }

    .active {
      color: #b78b1e;
      background: #1a1a1a;

      &:hover {
        color: #b78b1e !important;
      }
    }

    .logout {
      background-color: #b78b1e;
      border-color: #b78b1e;
      border-radius: 0;
      color: #fff;
    }
  }
}
</style>
